
<template>
  <div class="keyword-input" @click="handleFocus">
    <span class="placeholder" v-if="keywords.length == 0 && !value && isFocus == false">{{
      placeholder
    }}</span>
    <span class="keyword-input__tag" v-for="(key, i) in keywords" :key="i">
      {{ key }}<i class="iconfont tm-icon-plus" @click="handleRemove(i)"></i>
    </span>
    <div class="keyword-input__bottom">
      <input
        ref="keywordInputRef"
        class="keyword-input__value"
        type="text"
        v-model.trim="value"
        :maxlength="maxlength"
        :placeholder="keywords.length == 0 && !value ? '' : placeholder"
        @keyup="handleAddKeyword"
        @focus="isFocus = true"
        @blur="isFocus = false"
        :class="{ 'is-error': isError == true }"
      />
      <!-- <span class="keyword-input__num"> {{ wordLength }}/{{ total }} </span> -->
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, watch, inject } from 'vue';
export default {
  props: {
    modelValue: {
      type: String,
      required: true,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请按回车键输入',
    },
    maxlength: {
      type: Number,
      default: 200,
    },

    repeatMsg: {
      type: String,
      default: '',
    },
    maxNum: {
      type: Number,
    },
    maxNumMsg: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const keywordInputRef = ref(null);
    const $tm_message_box = inject('$tm_message_box');

    const state = reactive({
      value: '', // 输入框输入内容
      keywords: props.modelValue.split(';').filter((v) => v) || [],
      total: props.maxlength,
      isFocus: false,
    });

    const wordLength = computed(() => {
      return state.keywords.join('').length;
    });

    // 输入异常
    const isError = computed(() => {
      const { value, keywords } = state;
      // debugger;
      return (
        keywords.some((n) => n == value) || value.length > state.total
        // keywords.some((n) => n == value) || (wordLength.value || 0) + value.length > state.total
      );
    });

    watch(
      () => props.modelValue,
      (val) => {
        state.keywords = val.split(';').filter((v) => v);
      }
    );

    /**
     * @description: 添加关键词
     * @return {*}
     */
    function handleAddKeyword(e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        const { value, keywords } = state;
        if (!e.target.value.match(/\s$/g) && e.keyCode == 32) {
          //实现：输入法选中空格不响应
          return;
        }
        if (keywords.indexOf(value) > -1 && props.repeatMsg) {
          $tm_message_box.alert(props.repeatMsg, '', { type: 'warning' });
        }

        if (props.maxNumMsg && keywords.length >= props.maxNum) {
          $tm_message_box.alert(props.maxNumMsg, '', { type: 'warning' });
        } else if (
          value &&
          !keywords.some((n) => n == value) &&
          value.length <= state.total // (wordLength.value || 0) + 
        ) {
          state.keywords.push(value);
          state.value = '';
          emit('update:modelValue', state.keywords.join(';'));
        }

        return false;
      }
      e.stopPropagation();
      e.preventDefault();
    }

    /**
     * @description: 移除
     * @param {*} indexfasdf
     * @return {*}
     */
    function handleRemove(index) {
      state.keywords.splice(index, 1);
      emit('change', state.keywords);
      emit('update:modelValue', state.keywords.join(';'));
    }

    /**
     * @description: 激活
     * @return {*}
     */
    function handleFocus() {
      keywordInputRef.value?.focus();
      state.isFocus = true;
    }
    return {
      keywordInputRef,
      wordLength,
      isError,
      ...toRefs(state),
      handleAddKeyword,
      handleRemove,
      handleFocus,
    };
  },
};
</script>
<style lang="less" scoped>
.keyword-input {
  position: relative;
  width: 100%;
  padding: 8px 8px 30px;
  min-height: 94px;
  background: #f4f5f7;
  &__tag {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 2px 8px 2px 10px;
    background: #accefc;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    .tm-icon-plus {
      display: inline-block;
      margin-left: 10px;
      transform: rotate(45deg);
      cursor: pointer;
    }
  }
  &__bottom {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 15px;
    right: 10px;
    height: 30px;
    bottom: 0;
  }
  &__num {
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 400;
    color: #bebfc1;
  }
  &__value {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    &.is-error {
      color: red;
    }
    &::-webkit-input-placeholder {
      color: #a9acb3;
    }
    &::placeholder {
      color: #a9acb3;
    }
  }
  .placeholder {
    position: relative;
    top: -10px;
    padding-left: 10px;
    color: #a9acb3;
  }
  .keyword-input__num {
    font-size: 12px;
    margin-right: -7px;
  }
}
</style>
